<template>
  <el-form
    :label-position="labelPosition"
    :label-width="labelWidthFilter"
    :model="model"
    :rules="rules"
    @submit.native.prevent="doFilter"
    class="filter"
    ref="form"
  >
    <el-row>
      <el-col v-if="hasPermissionToAuditLogs" :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.id.label" :prop="fields.id.name">
          <el-input v-model="model[fields.id.name]" />
        </el-form-item>
      </el-col>
      <el-col :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.name.label" :prop="fields.name.name">
          <el-input v-model="model[fields.name.name]" />
        </el-form-item>
      </el-col>

      <!-- <el-col :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.gender.label" :prop="fields.gender.name">
          <el-select placeholder v-model="model[fields.gender.name]">
            <el-option :value="undefined">--</el-option>
            <el-option
              :key="option.id"
              :label="option.label"
              :value="option.id"
              v-for="option in fields.gender.options"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>-->

      <!-- <el-col :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.locations.label" :prop="fields.locations.name">
          <app-autocomplete-many-input
            :fetchFn="fields.locations.fetchFn"
            v-model="model[fields.locations.name]"
          ></app-autocomplete-many-input>
        </el-form-item>
      </el-col>
      -->

      <!-- <el-col :lg="12" :md="16" :sm="24">
        <el-form-item :label="fields.type.label" :prop="fields.type.name">
          <el-select placeholder v-model="model[fields.type.name]">
            <el-option :value="undefined">--</el-option>
            <el-option
              :key="option.id"
              :label="option.label"
              :value="option.id"
              v-for="option in fields.type.options"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>-->
    </el-row>

    <div class="filter-buttons">
      <el-button :disabled="loading" @click="doFilter" icon="el-icon-fa-search" type="primary">
        <app-i18n code="common.search"></app-i18n>
      </el-button>

      <!-- <el-button :disabled="loading" @click="doResetFilter" icon="el-icon-fa-undo">
        <app-i18n code="common.reset"></app-i18n>
      </el-button>-->
    </div>
  </el-form>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { mapGetters, mapActions } from 'vuex';
import { FilterSchema } from '@shared/form/filter-schema';
import { SubprogramModel } from '@modules/subprogram/subprogram-model';

export default {
  name: 'app-subprogram-list-filter',

  data() {
    return {
      model: {},
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthFilter: 'layout/labelWidthFilter',
      loading: 'subprogram/list/loading',
      filter: 'subprogram/list/filter',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    rules() {
      const { filterSchema } = this;
      return filterSchema.rules();
    },

    filterSchema() {
      const { fields } = this;
      return new FilterSchema([fields.id, fields.name]);
    },

    fields() {
      const { dateFormat, populateDate } = this;
      return new SubprogramModel({
        dateFormat,
        populateDate,
      }).fields();
    },
  },

  async mounted() {
    const { filterSchema } = this;

    this.model = filterSchema.initialValues(
      this.filter,
      this.$route.query,
    );

    return this.doFilter();
  },

  methods: {
    ...mapActions({
      doReset: 'subprogram/list/doReset',
      doFetch: 'subprogram/list/doFetch',
    }),

    async doResetFilter() {
      const { filterSchema } = this;
      this.model = filterSchema.initialValues();
      this.$refs.form.clearValidate();
      return this.doReset();
    },

    async doFilter() {
      const { filterSchema } = this;
      try {
        await this.$refs.form.validate();
        this.$refs.form.clearValidate();
      } catch (error) {
        return;
      }

      const filter = filterSchema.cast(this.model);
            
      return this.doFetch({
        filter,
      });
    },
  },
};
</script>

<style>
</style>
